<template>
  <v-dialog
    v-model="dialog"
    width="500">
    <template v-slot:activator="{ on }">
      <v-btn
        class="mr-3"
        v-on="on"
        :color="propBtnColor ? propBtnColor : 'default'"
        :disabled="propBtnDisabled ? propBtnDisabled : false"
        :dark="propBtnDark ? propBtnDark : false">
        {{ propActionBtnName }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        {{ propTitle }}
      </v-card-title>
      <v-card-text>
        {{ propText }}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <div class="flex-grow-1"></div>

        <v-btn text color="primary" @click="verify">{{ propBtnVerify }}</v-btn>
        <v-btn text @click="cancel">{{ propBtnCancel }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'VerifyDialog',

  props: [
    'propBtnColor',
    'propBtnDisabled',
    'propBtnDark',
    'propActionBtnName',
    'propTitle',
    'propText',
    'propBtnVerify',
    'propBtnCancel'
  ],

  data: () => ({
    dialog: false
  }),

  methods: {
    verify () {
      this.$emit('verify', true)
      this.dialog = false
    },

    cancel () {
      this.$emit('verify', false)
      this.dialog = false
    }
  }
}
</script>

<style>

</style>
